module.exports = __webpack_public_path__ + "c8076cc8c5f6d596fd817b7aaea1a987.png";